import AbstractRequestTask from "../AbstractRequestTask";
import Launcher from '../../apa/Launcher';
import {ENABLE_MODAL_RETRIES} from '../../RequestManagerConstants';
import settings from "src/devices/all/settings";
class PurchaseButtonInfoTask extends AbstractRequestTask {
  constructor(groupId = "", islive = null, validateLogin = false) {
    super();

    this.groupId = groupId;
    this.islive = islive;
    this.validateLogin = validateLogin;
  }

  getHeaders() {
    const params = super.getParams();
    const headers = {
      'Content-Type': 'application/json',
    };
    if(params.user_token) {
        headers["user-token"] = params.user_token;
    }
  
    return headers;
  }

  getUrl() {
    if(settings.fake_url_mockoon) {
      return `${settings.fake_url_mockoon}/services/payway/purchasebuttoninfo`;
    }
    else {
      const http = "https://";
      const url = Launcher.get("akamai_mfwk");
      return `${http}${url}/services/payway/v1/purchasebuttoninfo`;  
    } 
  }

  getParams() {
    const params = super.getParams();
    delete params.HKS;
    delete params.user_token;
    delete params.api_version;
    const newParams = {
      group_id: this.groupId,
      validatelogin: this.validateLogin,
      ...params
    };
    if(typeof this.islive === 'boolean'){
      newParams.islive = this.islive;
    }
    return newParams;
  }

  success(data, b) {
    this.resolve(data);
  }

  getShowErrorModal(){
		return ENABLE_MODAL_RETRIES;
	}
}

export default PurchaseButtonInfoTask;



// WEBPACK FOOTER //
// ./src/requests/tasks/payway/PurchaseButtonInfoTask.js